<template>
    <div class="table-card">

        <box-helper />

        <div class="table-title" v-if="heading">
            <i :class="'fas fa-fw fa-' + icon" v-if="icon" />
            {{ heading }}
        </div>
        
        <!--<v-text-field
            v-model="search"
            append-icon="search"
            label="Søg"
            single-line
            hide-details
        ></v-text-field>-->

       <v-data-table
            :search="search"
            :headers="headers"
            :items="items"
            :items-per-page="50"
            :class="customClass"
            v-if="!loading"
        >
            <no-data slot="no-data" />
            <div slot="footer.page-text">
                Footer text?
            </div>
        </v-data-table>

        <box-loading height="350" v-else />

        <div class="box-date-range" v-if="!loading">
            <div class="text">
                <i class="fal fa-calendar" />
            </div>
            <datepicker :language="datepickerLocale" class="date-picker" v-model="startDate" placeholder="Startdato"></datepicker>
            <div class="to">
                <i class="fal fa-chevron-right" />
            </div>
            <datepicker :language="datepickerLocale" class="date-picker" v-model="endDate" placeholder="Slutdato"></datepicker>
        </div>

    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'
    import * as projectService from '@/services/projectService'
    import moment from 'moment'
    import { da } from 'vuejs-datepicker/dist/locale'

    export default {
        data () {
            return {
                datepickerLocale: da,
                loading: true,
                search: '',
                startDate: this.$store.state.config.startDate,
                endDate: this.$store.state.config.endDate,
                data: []
            }
        },
        props: [
            'heading',
            'endpoint',
            'headers',
            'customClass',
            'icon',
            'group',
            'filters',
            'includes'
        ],
        computed: {
            companyId () {
                return this.$store.state.companyId || this.$auth.user().company_id
            },
            dataUrl () {
                return this.endpoint + '/' + this.companyId + '/' + this.formatDate(this.startDate) + '/' + this.formatDate(this.endDate) + this.filterString + this.includeString
            },
            storeStartDate () {
                return this.$store.state.config.startDate
            },
            storeEndDate () {
                return this.$store.state.endDate
            },
            items () {
                return this.data.map(project => {
                    return {
                        name: project.description,
                        customer: project.customer.name,
                        project: project.description,
                        projectType: project.type.name,
                        revenue: '-',
                        date: project.start_date,
                        db: project.coverage,
                        dbPerHour: project.coverage_per_hour,
                        dg: project.coverage_percent,
                        projectmanager: project.projectmanager
                    }
                })
            },
            filterString () {
                let filters = ''
                if (this.filters) { // Returns empty string if no filters are passed
                    Object.keys(this.filters).forEach((filter, filterCounter) => {
                        if (filterCounter === 0) {
                            filters += `?filter[${filter}]=`
                        } else {
                            filters += `&filter[${filter}]=`
                        }
                        this.filters[filter].forEach((value, valueCounter) => {
                            if (valueCounter === 0) {
                                filters += value
                            } else {
                                filters += `, ${value}`
                            }
                        })
                    })
                }
                return filters
            },
            includeString () {
                let includes = ''
                if (this.includes) { // Returns empty string if no includes are passed
                    if (this.filters) includes += '&' // Add '&' to string if filters are also passed
                    this.includes.forEach((include, includeCounter) => {
                        if (includeCounter === 0) {
                            includes += `include=${include}`
                        } else {
                            includes += `,${include}`
                        }
                    })
                }
                return includes
            }
        },
        methods: {
            getData () {
                this.loading = true
                projectService.find(this.dataUrl, {}, response => {
                    this.data = response.data.data
                    setTimeout(() => {
                        this.loading = false
                    }, 2000)
                }, (err) => {
                    console.log(err)
                    this.loading = false
                })
            },
            formatDate (date) {
                return moment(date).format('YYYY-MM-DD')
            }
        },
        created () {
            // this.getData()
        },
        watch: {
            storeStartDate: function (date) {
                this.startDate = date
            },
            storeEndDate: function (date) {
                this.endDate = date
            },
            dataUrl: function () {
                this.getData()
            }
        },
        components: {
            Datepicker
        }
    }
</script>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .v-data-table {
        min-height: 350px;
        animation: fadeIn 0.3s ease-in-out forwards;
    }

    .table-card {
        height: 100%;
        position: relative;

        .table-title {
            font-size: $fontsize--sm;
            padding: $padding--small;
            font-weight: $fontweight--bold;
            color: $color--white;
            background: $color--dark;
            text-align: center;
        }
    }

    .v-data-table td {
        font-size: $fontsize--small !important;
        font-weight: $fontweight--main !important;
        font-family: $fontfamily--secondary !important;
        cursor: pointer;

        &:first-of-type {
            font-weight: $fontweight--bold !important;
        }
    }

    .v-data-table th {

        span {
            float: left;
        }

        i {
            display: none !important;
        }
    }

    .v-data-table {
        
        &.finishedProjects {

            tr {

                td:last-of-type {
                    background: $color--bad;
                    color: $color--white;
                    font-weight: $fontweight--bold !important;
                }

                &:nth-of-type(1) td:last-of-type,
                &:nth-of-type(2) td:last-of-type {
                    background: $color--good;
                }

                &:nth-of-type(4) td:last-of-type {
                    background: $color--avg;
                }
            }
        }

        &.customerTypeRevenue,
        &.customerRevenue,
        &.revenueEarningsShare,
        &.customerContribution {

            tr {
                td:last-of-type {
                    background: $color--bad;
                    color: $color--white;
                    font-weight: $fontweight--bold !important;
                }

                &:nth-of-type(1) td:last-of-type,
                &:nth-of-type(2) td:last-of-type {
                    background: $color--good;
                }

                &:nth-of-type(3) td:last-of-type,
                &:nth-of-type(4) td:last-of-type {
                    background: $color--avg;
                }
            }
        }
    }

</style>

<style lang="scss">

    .v-data-table__wrapper {

        table {
            min-height: 300px;

            tbody {

                tr, td {
                    height: 50px !important;
                    max-height: 50px !important;

                    td {
                        overflow: hidden;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// TableCard.vue?0d43ba66